import React from 'react';

import { HOME_PAGE_VIDEO_LINK, HOME_PAGE_VIDEO_THUMBNAIL } from 'constants/data';
class VideoModal extends React.Component {
  constructor(props) {
    super(props);
    this.videoRef = null;
    this.openVideo = this.openVideo.bind(this);
    this.noChange = this.noChange.bind(this);
    this.state = {
      isModalOpen: false
    };
  }
  openVideo() {
    this.setState({ isModalOpen: !this.state.isModalOpen }, () => {
      if (this.videoRef && this.videoRef.current) {
        this.videoRef.current.focus();
      }
      document.body.classList.toggle('no-scroll');
    });
  }
  noChange(event) {
    event.stopPropagation();
  }
  render() {
    return (
      <div className="c-home-video-wrapper">
        <img className="video-img-wrapper" src={HOME_PAGE_VIDEO_THUMBNAIL} alt="video-thumnail" />
        <div className="play-button" onClick={this.openVideo}></div>
        <div className="rgi-text-wrapper">
          <p className="rgi-text">Discover the RGI</p>
        </div>
        {this.state.isModalOpen && (
          <div className="video-modal-container-wrapper" onClick={this.openVideo}>
            <div
              className="video-container"
              onClick={this.noChange}
              ref={this.videoRef}
              tabIndex="0"
              onKeyDown={(e) => {
                if (e.keyCode === 27) {
                  this.setState({ isModalOpen: !this.state.isModalOpen });
                  document.body.classList.toggle('no-scroll');
                }
              }}
            >
              <div className="video-wrapper">
                <video poster={HOME_PAGE_VIDEO_THUMBNAIL} controls autoPlay>
                  <source src={HOME_PAGE_VIDEO_LINK} type="video/mp4" />
                  Your browser does not support HTML5 video.
                </video>
              </div>
              <div className="close" onClick={this.openVideo}></div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
export default VideoModal;



// WEBPACK FOOTER //
// ./app/components/common/home/VideoModal.jsx